import { proxy, subscribe } from "valtio"

const generalSetup = proxy({
  sheetModal: {
    flag: false,
    action: "",
    obj: {}
  }, //歌单弹框对象
  personFlag: false, // 私人歌单显示
  visualFlag: false, // 可视化界面显示
  toScrollBot: false, // 是否到达内容底部
  playFlag: false, // 是否正在播放
  playFlagType: "footer" // 通过哪种方式改变的播放状态，footer组件或visual组件，添加这个属性的原因是这两个组件更改播放状态，不能同时控制两个组件里面的音乐播放（这种方法可能不太好，后面在看看吧）
})

// 私人歌单显示隐藏
const togglePersonFlag = () => {
  generalSetup.personFlag = !generalSetup.personFlag
}
// 可视化界面显示与隐藏
const toggleVisualFlag = () => {
  generalSetup.visualFlag = !generalSetup.visualFlag
  // console.log(generalSetup.visualFlag)
}
// 播放与暂停
const togglePlayFlag = (val) => {
  generalSetup.playFlag = val
  // console.log(generalSetup.playFlag)
}
// 播放状态类型更改
const changePlayFlagType = (type) => {
  generalSetup.playFlagType = type
}

subscribe(generalSetup, () => {
  // console.log(generalSetup)
})

export {
  toggleVisualFlag,
  togglePlayFlag,
  changePlayFlagType,
  togglePersonFlag
}
export default generalSetup
